import { AuthGuard } from '@core/auth/guards/auth.guard';
import { LayoutComponent } from '@shared/components/layout/layout.component';
import { Route } from '@angular/router';
import { AppResolvers } from './app.resolvers';
import { PermisoGuard } from '@core/auth/guards/permiso.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    resolve: [AppResolvers],
    children: [
      {
        path: 'ventas',
        canActivate: [PermisoGuard],
        loadChildren: () => import('./features/ventas/ventas.module').then(m => m.VentasModule),
      },
      {
        path: 'calculadora',
        canActivate: [PermisoGuard],
        loadChildren: () => import('./features/calculadora/calculadora.module').then(m => m.CalculadoraModule),
      },
      {
        path: 'clientes',
        canActivate: [PermisoGuard],
        loadChildren: () => import('./features/clientes/clientes.module').then(m => m.ClientesModule),
      },
      {
        path: 'taller',
        canActivate: [PermisoGuard],
        loadChildren: () => import('./features/taller/taller.module').then(m => m.TallerModule),
      },
      {
        path: "reportes",
        canActivate: [PermisoGuard],
        loadChildren: () => import("./features/reportes/reportes.module").then((m) => m.ReportesModule),
      },
      {
        path: '',
        redirectTo: '/materiales/articulos',
        pathMatch: 'full'
      },
      {
        path: 'materiales',
        canActivate: [PermisoGuard],
        loadChildren: () => import('./features/materiales/materiales.module').then(m => m.MaterialesModule),
      },
      {
        path: 'mantenimiento',
        canActivate: [PermisoGuard],
        loadChildren: () => import('./features/mantenimiento/mantenimiento.module').then(m => m.MantenimientoModule),
      },
      {
        path: 'comunicacion',
        canActivate: [PermisoGuard],
        loadChildren: () => import('./features/comunicacion/comunicacion.module').then(m => m.ComunicacionModule),
      },
      {
        path: 'rrhh',
        canActivate: [PermisoGuard],
        loadChildren: () => import('./features/rrhh/rrhh.module').then(m => m.RRHHModule),
      },
      {
        path: 'general',
        canActivate: [PermisoGuard],
        loadChildren: () => import('./features/general/general.module').then(m => m.GeneralModule),
      },
      {
        path: 'gerencia',
        canActivate: [PermisoGuard],
        loadChildren: () => import('./features/gerencia/gerencia.module').then(m => m.GerenciaModule),
      },
      {
        path: 'configuraciones',
        canActivate: [PermisoGuard],
        loadChildren: () => import('./features/configuraciones/configuraciones.module').then(m => m.ConfiguracionesModule),
      },
      {
        path: 'prospectos',
        canActivate: [PermisoGuard],
        loadChildren: () => import('./features/ventas/prospectos/prospectos.module').then(m => m.ProspectosModule),
      },
      {
        path: 'indicadores',
        canActivate: [PermisoGuard],
        loadChildren: () => import('./features/indicadores/indicadores.module').then(m => m.IndicadoresModule),
      },
      {
        path: 'indicadores/superset/:idDesktop/:idMobile',
        canActivate: [PermisoGuard],
        loadComponent: () =>
          import('./shared/components/superset/superset.component').then(m => m.SupersetComponent),
      },
      {
        path: 'common',
        canActivate: [PermisoGuard],
        loadChildren: () => import('./features/common-features/common-features.module').then(m => m.CommonFeaturesModule),
      },
      {
        path: 'applications',
        canActivate: [PermisoGuard],
        loadChildren: () => import('./features/applications/applications.module').then(m => m.ApplicationsModule),
      },
      {
        path: 'acceso-denegado',
        loadChildren: () => import('./shared/components/acceso-denegado/acceso-denegado.module').then(m => m.AccesoDenegadoModule)
      }
    ],
  },
  {
    path: '',
    component: LayoutComponent,
    data: { layout: 'empty' },
    children: [
      {
        path: 'sign-in',
        loadChildren: () => import('./features/auth/sign-in/sign-in.module').then(m => m.SignInFeatureModule),
      },
      {
        path: 'sign-out',
        loadChildren: () => import('./features/auth/sign-out/sign-out.module').then(m => m.SignOutFeatureModule),
      }
    ],
  },
  {
    path: '**',
    redirectTo: 'common/404',
  },
];
